(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('SurveyCampaignAddController', Controller);

    Controller.$inject = ['$scope', '$state', 'businessUnit', 'campaign'];

    function Controller($scope, $state, businessUnit, campaign) {
        
        $scope.businessUnit = businessUnit;
        $scope.campaign = campaign;
        
        // Go To External Party List
        $scope.goToCampaignList = function () {
            $state.go('odd.surveyCampaigns');
        };

        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', { ODDBusinessUnitID: businessUnit.ODDBusinessUnitID }, { reload: true });
        };

    }
})();